import Vue from 'vue'
import { IS_LOADING } from '../constants.js'
import { CUSTOMER_COS, SET_CUSTOMER_COS, SET_IS_LOADING_COS } from './constants.js'

const setIsLoadingCos = function (state, payload) {
	Vue.set(state, CUSTOMER_COS, {
		...state[CUSTOMER_COS],
		[IS_LOADING]: payload
	})
}

const setCustomerCos = function (state, payload) {
	Vue.set(state, CUSTOMER_COS, {
		...state[CUSTOMER_COS],
		objects: payload
	})
}

const mutations = {
	[SET_IS_LOADING_COS] (state, payload) {
		setIsLoadingCos(state, payload)
	},
	[SET_CUSTOMER_COS] (state, payload) {
		setCustomerCos(state, payload)
	}
}

export {
	mutations
}
